'use es6';

import { css } from 'styled-components';
export const INPUT_STYLES = css(["&&{min-height:2.5em;span{font-size:14px;}}"]);